import { Link } from "react-router-dom";
import { siteInfo, hotKeywords } from "@/mocks/site";

const topicLinks = [
  { label: "综艺现场", to: "/topics" },
  { label: "影视动态", to: "/topics" },
  { label: "音乐现场", to: "/topics" },
  { label: "品牌代言", to: "/topics" },
  { label: "网络热议", to: "/topics" },
  { label: "海外娱乐", to: "/topics" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200 border-t border-background-300/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-600 max-w-xs">
              {siteInfo.slogan}。把全网正在讨论的热点集中到一屏，打开就知道今天在聊什么。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-700">
              <span className="w-4 h-4 flex items-center justify-center text-secondary-600">
                <i className="ri-time-line" aria-hidden="true"></i>
              </span>
              {siteInfo.hours}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {topicLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">网站导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  分类专题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  线索投稿
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">热门话题</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotKeywords.slice(0, 8).map((word) => (
                <Link
                  key={word}
                  to="/topics"
                  className="rounded-full border border-background-300/80 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  #{word}
                </Link>
              ))}
            </div>
            <div className="mt-5 space-y-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </span>
                {siteInfo.email}
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                  <i className="ri-hand-coin-line" aria-hidden="true"></i>
                </span>
                {siteInfo.cooperation}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 border-t border-background-300/70 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.name}. 内容整理自公开讨论，仅供娱乐资讯参考。
          </p>
          <p className="text-xs text-foreground-500">
            如对内容有异议，欢迎通过邮箱联系，我们会及时核对与更新。
          </p>
        </div>
      </div>
    </footer>
  );
}